import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { postJwtRegister } from "../../services/auth";
// import BottomFooter from "../../components/BottomFooter";
import { toast } from "sonner";
import zxcvbn from "zxcvbn";

function Regsiter() {
  const navigate = useNavigate();
  const [isShowPassword, setIsShowPassword] = React.useState(false);

  const { mutate, isPending, isError, error } = useMutation({
    mutationFn: postJwtRegister,
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,

    initialValues: {
      username: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      dateOfBirth: "1995-06-15T00:00:00",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your Username"),
      // firstName: Yup.string().required("Please Enter Your firstname"),
      // lastName: Yup.string().required("Please Enter Your lastname"),
      // email: Yup.string().email().required("Please Enter Your Email"),
      phone: Yup.string().required("Please Enter Your Phone"),
      password: Yup.string()
        .required("Please Enter Your Password")
        .min(6, "Password must be at least 6 characters") // RequiredLength
        .matches(/[0-9]/, "Password must contain at least one digit") // RequireDigit
        .matches(/[a-z]/, "Password must contain at least one lowercase letter") // RequireLowercase
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter") // RequireUppercase
        .matches(
          /[^a-zA-Z0-9]/,
          "Password must contain at least one special character",
        ) // RequireNonAlphanumeric
        .test(
          "unique-chars",
          "Password must contain at least 4 unique characters",
          (value) => {
            if (!value) return false;

            const uniqueChars = new Set(value.split(""));
            return uniqueChars.size >= 4;
          },
        ), // RequiredUniqueChars
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: (values) => {
      let reqData = { user: { ...values } };

      mutate(reqData, {
        onSuccess: (data) => {
          console.log(data);
          toast.success(
            "user has been created successfully, a confirmation email has been sent to ur email",
          );

          navigate(
            `/auth/login?message=user has been created successfully, a confirmation email has been sent to your email ${reqData["user"].email}`,
            { replace: true },
          );
        },
        onError: (error) => {
          console.log(error);
          toast.error("Unable to create a user.");
        },
      });
    },
  });

  const passwordStrength = zxcvbn(validation.values.password || "");

  const passwordChecks = {
    length: validation.values.password.length >= 6,
    uppercase: /[A-Z]/.test(validation.values.password),
    lowercase: /[a-z]/.test(validation.values.password),
    digit: /[0-9]/.test(validation.values.password),
    special: /[^a-zA-Z0-9]/.test(validation.values.password),
    unique: new Set(validation.values.password.split("")).size >= 4,
  };

  return (
    <React.Fragment>
      <div className="auth-page-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-7 col-lg-7 col-xl-4">
              <div className="card mt-24 shadow-lg border-0">
                <div className="card-body p-24">
                  {isError && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}

                  <div className="text-center mt-2">
                    <h6 className="text-dark mb-1">Create New Account</h6>
                    <p className="text-muted">
                      Sign up to continue to phAMACart.
                    </p>
                  </div>
                  <div className="p-2 mt-24">
                    <form
                      action="#"
                      autoComplete="off"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-16">
                        <label className="form-label">Username</label>
                        <input
                          type="text"
                          className={`form-control ${
                            validation.touched.username &&
                            validation.errors.username &&
                            "is-invalid"
                          }`}
                          id="username"
                          name="username"
                          placeholder="Enter username"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                        />
                      </div>
                      <div className="mb-16">
                        <div className="hstack gap-3">
                          <div className="w-100">
                            <label className="form-label">FirstName</label>
                            <input
                              type="text"
                              className={`form-control ${
                                validation.touched.firstName &&
                                validation.errors.firstName &&
                                "is-invalid"
                              }`}
                              id="firstName"
                              name="firstName"
                              placeholder="Enter firstName"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.firstName || ""}
                            />
                          </div>
                          <div className="w-100">
                            <label className="form-label">LastName</label>
                            <input
                              type="text"
                              className={`form-control ${
                                validation.touched.lastName &&
                                validation.errors.lastName &&
                                "is-invalid"
                              }`}
                              id="lastName"
                              name="lastName"
                              placeholder="Enter lastName"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.lastName || ""}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mb-16">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className={`form-control ${
                            validation.touched.email &&
                            validation.errors.email &&
                            "is-invalid"
                          }`}
                          id="email"
                          name="email"
                          placeholder="Enter email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                        />
                      </div>
                      <div className="mb-16">
                        <label className="form-label">Phone</label>
                        <input
                          type="t"
                          className={`form-control ${
                            validation.touched.phone &&
                            validation.errors.phone &&
                            "is-invalid"
                          }`}
                          id="phone"
                          name="phone"
                          placeholder="07XXXXXXXX"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone || ""}
                        />
                      </div>
                      <div className="mb-16">
                        <label className="form-label">Password</label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <input
                            type={isShowPassword ? "text" : "password"}
                            id="password"
                            name="password"
                            value={validation.values.password || ""}
                            className={`form-control pe-5 ${
                              validation.touched.password &&
                              validation.errors.password &&
                              "is-invalid"
                            }`}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                          />
                          <span
                            className={`toggle-password position-absolute top-50 inset-inline-end-0 me-30 translate-middle-y cursor-pointer`}
                            id="#enter-password"
                            onClick={() => setIsShowPassword(!isShowPassword)}
                          >
                            <i
                              className={`${isShowPassword ? "ph ph-eye-slash" : "ph ph-eye"}`}
                            />
                          </span>
                        </div>
                        {/* <p className="invalid-feedback">
                          {validation.errors.password}
                        </p> */}
                        {/* Strength Meter */}
                        {validation.errors.password && (
                          <div className="mt-2">
                            <div className="progress" style={{ height: "6px" }}>
                              <div
                                className={`progress-bar ${
                                  passwordStrength.score <= 1
                                    ? "bg-danger"
                                    : passwordStrength.score === 2
                                      ? "bg-warning"
                                      : passwordStrength.score >= 3
                                        ? "bg-success"
                                        : ""
                                }`}
                                role="progressbar"
                                style={{
                                  width: `${(passwordStrength.score + 1) * 20}%`,
                                }}
                              />
                            </div>

                            <small className="text-muted">
                              Strength:{" "}
                              {
                                ["Very Weak", "Weak", "Fair", "Good", "Strong"][
                                  passwordStrength.score
                                ]
                              }
                            </small>
                          </div>
                        )}
                        {/* Requirement Checklist */}
                        {validation.values.password && (
                          <ul className="list-unstyled small mt-3 mb-0">
                            <li
                              className={
                                passwordChecks.length
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {passwordChecks.length ? "✓" : "✗"} Minimum 6
                              characters
                            </li>

                            <li
                              className={
                                passwordChecks.uppercase
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {passwordChecks.uppercase ? "✓" : "✗"} One
                              uppercase letter
                            </li>

                            <li
                              className={
                                passwordChecks.lowercase
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {passwordChecks.lowercase ? "✓" : "✗"} One
                              lowercase letter
                            </li>

                            <li
                              className={
                                passwordChecks.digit
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {passwordChecks.digit ? "✓" : "✗"} One number
                            </li>

                            <li
                              className={
                                passwordChecks.special
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {passwordChecks.special ? "✓" : "✗"} One special
                              character
                            </li>

                            <li
                              className={
                                passwordChecks.unique
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {passwordChecks.unique ? "✓" : "✗"} 4 unique
                              characters
                            </li>
                          </ul>
                        )}
                        {/* zxcvbn feedback */}
                        {validation.values.password &&
                          passwordStrength.feedback.warning && (
                            <div className="text-warning small mt-2">
                              {passwordStrength.feedback.warning}
                            </div>
                          )}
                      </div>
                      <div className="mb-16">
                        <label className="form-label">Confirm Password</label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <input
                            type={isShowPassword ? "text" : "password"}
                            id="confirmPassword"
                            name="confirmPassword"
                            value={validation.values.confirmPassword || ""}
                            className={`form-control pe-5 ${
                              validation.touched.confirmPassword &&
                              validation.errors.confirmPassword &&
                              "is-invalid"
                            }`}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                          />
                          <span
                            className={`toggle-password position-absolute top-50 inset-inline-end-0 me-30 translate-middle-y cursor-pointer`}
                            id="#enter-password"
                            onClick={() => setIsShowPassword(!isShowPassword)}
                          >
                            <i
                              className={`${isShowPassword ? "ph ph-eye-slash" : "ph ph-eye"}`}
                            />
                          </span>
                        </div>
                        <p className="invalid-feedback">
                          {validation.errors.confirmPassword}
                        </p>
                      </div>
                      <div className="mb-16">
                        <p className="text-gray-500">
                          Your personal data will be used to process your order,
                          support your experience throughout this website, and
                          for other purposes described in our
                          <Link
                            to="#"
                            className="text-main-600 text-decoration-underline"
                          >
                            {" "}
                            privacy policy
                          </Link>
                          .
                        </p>
                      </div>
                      <div className="mt-24">
                        <button
                          type="submit"
                          className="btn btn-success w-100"
                          disabled={isPending}
                        >
                          {isPending && (
                            <div
                              className="spinner-border spinner-border-sm me-5"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                          Sign Up
                        </button>
                      </div>

                      <div className="mt-24 text-center">
                        <p className="mb-0">
                          Already have an account ?{" "}
                          <Link
                            className="fw-semibold text-primary text-decoration-underline"
                            to="/auth/login"
                            data-discover="true"
                          >
                            {" "}
                            Signin{" "}
                          </Link>{" "}
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* BottomFooter */}
      {/* <div id="footer">
        <BottomFooter />
      </div> */}
    </React.Fragment>
  );
}

export default Regsiter;
